var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
import { forwardRef } from "react";
const SvgCreditCardIcon = (_ref, ref) => {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 18,
    height: 14,
    viewBox: "0 0 16 14",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: ref,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M13.75 3H3.75C3.3125 3 3 3.34375 3 3.75C3 4.1875 3.3125 4.5 3.75 4.5H13.75C14.1562 4.5 14.5 4.84375 14.5 5.25V11.75C14.5 12.1875 14.1562 12.5 13.75 12.5H2.75C2.03125 12.5 1.5 11.9688 1.5 11.25V2.75C1.5 2.0625 2.03125 1.5 2.75 1.5H14.25C14.6562 1.5 15 1.1875 15 0.75C15 0.34375 14.6562 0 14.25 0H2.75C1.21875 0 0 1.25 0 2.75V11.25C0 12.7812 1.21875 14 2.75 14H13.75C14.9688 14 16 13 16 11.75V5.25C16 4.03125 14.9688 3 13.75 3ZM13 8.5C13 7.96875 12.5312 7.5 12 7.5C11.4375 7.5 11 7.96875 11 8.5C11 9.0625 11.4375 9.5 12 9.5C12.5312 9.5 13 9.0625 13 8.5Z",
    fill: "#8D9EAF"
  })));
};
const ForwardRef = /*#__PURE__*/forwardRef(SvgCreditCardIcon);
export { ForwardRef as ReactComponent };
export default __webpack_public_path__ + "static/media/credit-card-icon.82fb88b05cb962a690db72734a076cf0.svg";